<template>
  <v-menu
    ref="timePicker"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290"
    min-width="290"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="value"
        readonly
        persistent-hint
        dense
        :clearable="value && value != '' ? true : false"
        clear-icon="mdi-close-circle"
        @click:clear="$emit('input', '')"
        @click:append="menu = true"
        :disabled="disabled"
        outlined
                :error="!error || error == '' ? false : true"
        hide-details
        style="max-width: 120px"
        :label="label"
        :append-icon="!value ? 'mdi-clock-time-nine-outline' : null"
        :error-messages="error"
        v-on="on"
        v-bind="attributesBinding"
      ></v-text-field>
    </template>
    <v-time-picker
      :value="value"
      format="24hr"
      :min="min"
      :max="max"
      :locale="locale"
      @change="onChangetime($event)"
    ></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: String,
    locale: {
      type: String,
      default: "ja",
    },
    error: String,
    disabled: Boolean,
    label: String,
    min: String,
    max: String,
    autofocus: {
      type: Boolean,
      default: false,
    },
  }, // Use "value" here to enable compatibility with v-model
  data() {
    return {
      menu: false,
      classList: "",
    };
  },
  methods: {
    onChangetime(event) {
      this.menu = false;
      this.$emit("input", event);
    },
  },
  mounted() {
    this.classList = this.$refs.timePicker.$el.classList;
  },
  computed: {
    attributesBinding() {
      var attr = {};
      for (let i = 0; i < this.classList.length; i++) {
        if (this.classList[i] !== "v-menu") {
          attr.class = this.classList[i];
          console.log(this.classList[i]);
        }
      }
      return attr;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>